import { Menu } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { toggleCollapse } from '@kss/layouts';
import SearchBar from './SearchBar';
import ThemeSwitcher from './ThemeSwitcher';
import ColorModeToggle from './ColorModeToggle';
import FullscreenToggle from './FullscreenToggle';
import LanguageSwitcher from './LanguageSwitcher';
import NotificationBell from './NotificationBell';
import UserProfileDropdown from './UserProfileDropdown';
import Breadcrumb from './Breadcrumb';

export default function TopBar() {
  const dispatch = useDispatch();

  return (
    <header className="no-print flex h-14 items-center border-b border-border bg-surface-topbar px-4">
      {/* Left */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => dispatch(toggleCollapse())}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-content-muted hover:bg-surface-card-hover hover:text-content-primary transition-colors"
        >
          <Menu size={18} />
        </button>
        <Breadcrumb />
      </div>

      {/* Center - Search */}
      <div className="mx-4 flex-1 max-w-md">
        <SearchBar />
      </div>

      {/* Right */}
      <div className="flex items-center gap-1">
        <ThemeSwitcher />
        <ColorModeToggle />
        <FullscreenToggle />
        <LanguageSwitcher />
        <NotificationBell />
        <UserProfileDropdown />
      </div>
    </header>
  );
}
